
const Footer = () => {
    return (
        <div className="Footer m-2">
            <p>Jani Luostarinen 2025. Made using React and Bootstrap.</p>
        </div>
    );
};
export default Footer;